import { registerServiceWorker } from '@backoffice-frontend/common'
import {
  ENV,
  Environment,
  sentryRelease,
  serviceWorkerDebugEnabled,
} from '@backoffice-frontend/environment'
import * as Sentry from '@sentry/browser'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { PerformanceTracker } from './performance-tracker'

if (
  (serviceWorkerDebugEnabled || window.location.hostname !== 'localhost') &&
  (ENV === Environment.production || ENV === Environment.integration)
) {
  Sentry.init({
    dsn: 'https://fb8de72a7a01c605a53639b30988c1eb@o4508878881685504.ingest.de.sentry.io/4508878913077328',
    environment: ENV,
    release: sentryRelease,
    ignoreErrors: [
      'Non-Error promise rejection captured with value: The user is not authenticated',
      `ReferenceError: Can't find variable: msDiscoverChatAvailable`,
      'CWR: Failed to retrieve Cognito identity: TypeError: Load failed',
      'Error: CWR: Failed to retrieve Cognito identity: TypeError: Failed to fetch',
      'CWR: Failed to retrieve credentials from STS: TypeError: Load failed',
    ],
    integrations: [
      {
        name: 'FilterHereMapsErrors',
        setupOnce: () => {},
        processEvent(event, hint) {
          try {
            const isThrownByHereMaps =
              // biome-ignore lint/suspicious/noExplicitAny: We've got to work with what we got ...
              (hint.originalException as any).stack.includes(
                '@here/maps-api-for-javascript',
              )

            if (isThrownByHereMaps) {
              return null
            }

            return event
          } catch {
            return event
          }
        },
      },
    ],
  })

  registerServiceWorker()
}

PerformanceTracker()

// bootstrap react app
const container = document.getElementById('page')

if (!container) {
  throw new Error('Could not find the root element')
}

const root = createRoot(container)
root.render(<App />)
